import { useSyncExternalStore } from "react";

export const FAV = "gg_favorites";
export const PLAYED = "gg_played";
const VOTES = "gg_votes";

const listeners = new Set();
const cache = {};

function read(k, fallback) {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? fallback;
  } catch {
    return fallback;
  }
}

function get(k) {
  if (!(k in cache)) cache[k] = read(k, []);
  return cache[k];
}

function set(k, v) {
  cache[k] = v;
  try {
    localStorage.setItem(k, JSON.stringify(v));
  } catch {
    /* storage full or blocked */
  }
  listeners.forEach((l) => l());
}

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const useList = (k) => useSyncExternalStore(subscribe, () => get(k));

export const toggleFav = (slug) => {
  const l = get(FAV);
  set(FAV, l.includes(slug) ? l.filter((s) => s !== slug) : [slug, ...l].slice(0, 100));
};

export const pushPlayed = (slug) => set(PLAYED, [slug, ...get(PLAYED).filter((s) => s !== slug)].slice(0, 40));
export const clearPlayed = () => set(PLAYED, []);

export const getVote = (slug) => read(VOTES, {})[slug] || null;
export const saveVote = (slug, v) => {
  const all = read(VOTES, {});
  all[slug] = v;
  localStorage.setItem(VOTES, JSON.stringify(all));
};
